/* eslint-disable react-hooks/exhaustive-deps */
import LoadingCustom from "@/components/ui/Loading";
import {
  ICategorizationInfo,
  ITreeInfo,
} from "@/components/ui/TreeSelect/Models";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import {
  IFilterResource,
  ISessionData,
  OrganizationInfo,
  Organizer,
  ResourceInfo,
} from "@/services";
import { OutLookInfo } from "@/services/organization-service/entity/OutLookEntity";
import { useEffect, useState } from "react";
import FloorPlanDialog from "../floor-plan/ResourceFloorPlanContainer";
import { IFloorPlanInitialProps } from "./Model";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { useSelector } from "react-redux";
import { RootState } from "@/redux";
import { DateTimeFormat } from "@/services/setting-service/entity/SettingResponseModel";

const FloorPlanInitial = (props: IFloorPlanInitialProps) => {
  const orgStore: IOrganizationStore = useSelector(
    (state: RootState) => state.orgInfo
  ) as IOrganizationStore;
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    onGetDataSessionForProps();
  }, [window.location.search]);

  const onGetDataSessionForProps = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramsObject = Object.fromEntries(searchParams.entries());

    if (props.onGetDataSessionFloorPlan && paramsObject?.sessionId) {
      setLoading(true);
      const resp: HttpResponse<ISessionData> =
        await props.onGetDataSessionFloorPlan(paramsObject.sessionId);
      setLoading(false);
      if (!resp.error) {
        updateOrgInfoToRedux(new OrganizationInfo(resp.data.orgInfo));
        if (resp.data.outlookInfo) {
          const outlookInfo = {
            ...resp.data.outlookInfo,
            Start: new Date(resp.data.outlookInfo.Start),
            End: new Date(resp.data?.outlookInfo.End),
            DisplayStartTime: new Date(resp.data.outlookInfo?.DisplayStartTime || ""),
            DisplayEndTime: new Date(resp.data.outlookInfo?.DisplayEndTime || ""),
            StartTimeNotConvert: new Date(resp.data.outlookInfo?.StartTimeNotConvert || ""),
            EndTimeNotConvert: new Date(resp.data.outlookInfo?.EndTimeNotConvert || ""),
            Occurrences: resp.data.outlookInfo.Occurrences.map((item) => {
              return {
                StartTicks: item.StartTicks,
                EndTicks: item.EndTicks,
                Start: new Date(item.Start || ""),
                End: new Date(item.End || ""),
              };
            }),
          };
          updateOutlookInfoToRedux(new OutLookInfo(outlookInfo));
        }
        updateOrganizerToRedux(new Organizer(resp.data?.organizer));
        if (resp.data.settingInfo) {
          resp.data.settingInfo.dateTimeFormat = new DateTimeFormat(
            resp.data.settingInfo.dateTimeFormat
          );
        }
        updateSettingToRedux(resp.data.settingInfo);
        getCategorization(
          resp.data?.locationTrees || [],
          resp.data?.categoryTrees || [],
          resp.data.locationList || []
        );
        updateAllResourcesSelectedFromParent(
          (resp.data.selectedResource || []).map(
            (item) => new ResourceInfo(item, true)
          )
        );
        updateFilterResource(resp.data.filterResource);
      }
    }
  };

  const getCategorization = (
    locationTrees: ITreeInfo[],
    categoryTrees: ITreeInfo[],
    locationList: ICategorizationInfo[]
  ): void => {
    if (props.getCategorization) {
      props.getCategorization(locationTrees, categoryTrees, locationList);
    }
  };

  const updateOutlookInfoToRedux = (outlookInfo: OutLookInfo): void => {
    if (props.updateOutlookInfo) {
      props.updateOutlookInfo(outlookInfo);
    }
  };

  const updateSettingToRedux = (settingInfo: ISettingStore): void => {
    if (props.updateSettings) {
      props.updateSettings(settingInfo);
    }
  };

  const updateOrganizerToRedux = (organizer: Organizer) => {
    if (props.updateOrganizer) {
      props.updateOrganizer(organizer);
    }
  };

  const updateOrgInfoToRedux = (orgInfo: OrganizationInfo) => {
    if (props.updateOrgInfo) {
      props.updateOrgInfo(orgInfo);
    }
  };

  const updateAllResourcesSelectedFromParent = (resources: ResourceInfo[]) => {
    if (props.updateAllResourcesSelectedFromParent) {
      props.updateAllResourcesSelectedFromParent(resources);
    }
  };

  const updateFilterResource = (filterRs: IFilterResource) => {
    if (props.onUpdateFilterResource) {
      props.onUpdateFilterResource(filterRs);
    }
  };

  console.log("store", orgStore);

  return loading ? (
    <LoadingCustom />
  ) : (
    <FloorPlanDialog messageToParent={props.messageToParent} />
  );
};

export default FloorPlanInitial;
